document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('mobile-drawer');
  const btn = document.querySelector('.hamburger');
  const closeBtn = document.querySelector('.drawer-close');

  function openDrawer(){
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    if (btn) btn.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(){
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    if (btn) btn.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }

  if (btn) btn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (drawer) drawer.addEventListener('click', (e) => {
    if (e.target === drawer) closeDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
});

// Variant swatches controller: dynamic availability for up to 3 options
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[id^="Variants-"]').forEach(function(scriptEl){
    var productId = scriptEl.id.replace('Variants-','');
    var data;
    try { data = JSON.parse(scriptEl.textContent); } catch(e){ return; }
    var container = document.querySelector('#option-groups-' + productId);
    if (!container || !data || !data.variants) return;
    var hiddenInput = container.parentElement.querySelector('#variant-id');
    var addBtn = container.parentElement.querySelector('#add-to-cart');

    // Build state
    var options = data.options || [];
    var variants = data.variants || [];

    // Helpers
    function matches(v, sel){
      // sel: {1: 'Color', 2: 'Size', 3: 'Other'}
      for (var k in sel){
        var idx = parseInt(k,10);
        var key = 'option' + idx;
        if (sel[k] && v[key] !== sel[k]) return false;
      }
      return true;
    }
    function anyAvailable(filter){
      return variants.some(function(v){ return v.available && matches(v, filter); });
    }
    function findVariant(sel){
      // prioritize available match
      for (var i=0;i<variants.length;i++){
        var v = variants[i];
        if (matches(v, sel)) return v;
      }
      return null;
    }

    // Query buttons by option index
    var groups = {};
    container.querySelectorAll('.option-group').forEach(function(g){
      var idx = g.getAttribute('data-option-index');
      groups[idx] = g.querySelectorAll('.option-btn');
    });

    // Current selection (start with first available variant if any)
    var selection = {};
    var firstAvail = variants.find(function(v){ return v.available; }) || variants[0];
    if (firstAvail){
      if (options[0]) selection[1] = firstAvail.option1;
      if (options[1]) selection[2] = firstAvail.option2;
      if (options[2]) selection[3] = firstAvail.option3;
    }

    function render(){
      // For each option index, compute which values are enabled given other selections
      Object.keys(groups).forEach(function(idxStr){
        var idx = parseInt(idxStr,10);
        var btns = groups[idxStr];
        btns.forEach(function(btn){
          var val = btn.getAttribute('data-option-value');
          var filter = {};
          // lock other selections
          Object.keys(selection).forEach(function(k){
            if (parseInt(k,10) !== idx && selection[k]) filter[k] = selection[k];
          });
          // test if there exists an available variant with this value at current index
          filter[idx] = val;
          var enabled = anyAvailable(filter);
          btn.disabled = !enabled;
          btn.classList.toggle('disabled', !enabled);
          // active state
          var isActive = selection[idx] === val;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });

      // Resolve to a concrete variant id based on current selection
      var v = findVariant(selection);
      if (v && v.available){
        hiddenInput.value = v.id;
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
      } else {
        // If the exact combo isn't available, disable Add to cart
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled','true');
      }
    }

    // Wire up clicks
    Object.keys(groups).forEach(function(idxStr){
      var idx = parseInt(idxStr,10);
      groups[idxStr].forEach(function(btn){
        btn.addEventListener('click', function(){
          if (btn.disabled) return;
          selection[idx] = btn.getAttribute('data-option-value');
          render();
        });
      });
    });

    render();
  });
});


// Product gallery: swap hero image when a thumbnail is clicked
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.product-gallery').forEach(function(gal){
    var hero = gal.querySelector('.gallery-hero .hero-slot[data-hero-index="0"] .hero-img');
    if (!hero) return;
    gal.querySelectorAll('.gallery-thumbs .thumb').forEach(function(btn){
      btn.addEventListener('click', function(){
        var full = btn.getAttribute('data-full');
        if (full) hero.setAttribute('src', full);
        gal.querySelectorAll('.gallery-thumbs .thumb').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  });
});